export default "__VITE_ASSET__gAvYHcs___"